import React from 'react'
import { Card, CardContent, Box, Typography, Avatar, useTheme, alpha } from '@mui/material'

interface WelcomeCardProps {
  userName: string
  showLogo?: boolean
}

const WelcomeCard: React.FC<WelcomeCardProps> = ({ userName, showLogo = true }) => {
  const theme = useTheme()
  
  return (
    <Card
      sx={{
        background: `linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)`,
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        minHeight: 100,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -50,
          right: -50,
          width: 200,
          height: 200,
          borderRadius: '50%',
          background: `linear-gradient(45deg, ${alpha(theme.palette.common.white, 0.1)} 0%, ${alpha(theme.palette.common.white, 0.2)} 100%)`,
        }}
      />
      <CardContent sx={{ p: 2, pb: 1.5, position: 'relative', zIndex: 1 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" mb={0.5}>
            <Avatar sx={{ width: 40, height: 40, mr: 2, bgcolor: alpha(theme.palette.common.white, 0.2) }}>
              {userName.charAt(0).toUpperCase()}
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight="bold" sx={{ color: 'white' }}>
                Hello, {userName}! 👋
              </Typography>
              <Typography variant="body2" sx={{ color: 'white', opacity: 0.9, mt: 0.25, fontSize: '0.875rem' }}>
                Nice to have you back! Get ready to continue your learning journey.
              </Typography>
            </Box>
          </Box>
          
          {showLogo && (
            <Box
              sx={{
                display: { xs: 'none', md: 'block' }, // Hide on mobile
                mr: 2,
              }}
            >
              <img
                src="/devon-logo-blue.webp"
                alt="Devon Learning Platform"
                style={{
                  height: '60px',
                  maxWidth: '200px',
                  objectFit: 'contain',
                }}
              />
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export default WelcomeCard